import React from 'react';
import Modal from '../Modal/Modal';
import IconCollection from '../IconCollection/IconCollection';
import { IconSpinner } from '..';

import css from './FolderDocumentModal.module.css';
import { FOLDER_DOCUMENT_PAGE_SIZE } from '../../containers/MyGroupCommunityPage/MyGroupCommunityPage.duck';
import PaginationMyActivity from '../../containers/CircleCommunityPage/components/MyActivity/PaginationMyActivity';

const FolderDocumentModal = props => {
  const {
    isFolderDocument,
    onToggelFolderDocument,
    onManageDisableScrolling,
    spaceDetail,
    fetchFolderDocumentRequest,
    fetchFolderDocumentError,
    allFolderDocuments,
    updateFolderDocumentRequest,
    updateFolderDocumentError,
    onUpdateGroupDocumentFolder,
    onFetchGroupDocumentFolder,
    onToggelAddFolder,
    intl,
    toastifyFn
  } = props;

  const { folderName } = isFolderDocument || {};

  const { can_manage_space, can_view_space } = spaceDetail?.policies || {};
  const userHaveDocumnetViewPermissions = can_manage_space || can_view_space;
  const userHaveDocumnetUpadtePermissions = can_manage_space;

  const deleteDocumentSuccess = intl.formatMessage({ id: 'FolderDocumentModal.deleteDocumentSuccess' });
  const deleteDocumentError = intl.formatMessage({ id: 'FolderDocumentModal.deleteDocumentError' });;

  const {
    data: allFolderDocumentData,
    pagination
  } = allFolderDocuments || {};

  const {
    totalItems,
    totalPages,
    page,
    perPage,
  } = pagination || {};

  const onDeleteFolder = (item) => {

    const {
      _id,
      groupId,
      folderId,
    } = item;

    const deleteData = {
      id: _id,
      payload: {
        isDelete: true,
      }
    };

    const fetchData = {
      payload: {
        groupId,
        folderId,
        isActive: true,
        isDelete: false
      },
      pageParams: {
        page: page > 1 && allFolderDocumentData.length > 1 ? page : 1,
        perPage: FOLDER_DOCUMENT_PAGE_SIZE,
      }
    };

    return onUpdateGroupDocumentFolder(deleteData, fetchData)
      .then((res) => {
        toastifyFn('success', deleteDocumentSuccess);
        return res;
      })
      .catch((e) => {
        toastifyFn('error', deleteDocumentError);
        console.log(e, '&&& &&& => e');
        return e;
      })
  }

  const handlePageChange = newPage => {
    const { groupId, folderId } = allFolderDocumentData?.[0] || [];
    onFetchGroupDocumentFolder({
      payload: {
        groupId,
        folderId,
        isActive: true,
        isDelete: false,
      },
      pageParams: {
        page: newPage,
        perPage: FOLDER_DOCUMENT_PAGE_SIZE,
      },
    });
  };

  return (
    <Modal
      id={'folderDocumentModal'}
      isOpen={!!(isFolderDocument && userHaveDocumnetViewPermissions)}
      onClose={() => onToggelFolderDocument(false)}
      onManageDisableScrolling={onManageDisableScrolling}
      className={css.folderModal}
    >
      <div className={css.modalContainer}>
        <div className={css.header}>
          <span>{folderName}</span>
          {userHaveDocumnetUpadtePermissions ? (
            <span
              className={css.icon}
              onClick={e => {
                e.preventDefault();
                console.log(isFolderDocument, 'isFolderDocument');
                onToggelAddFolder(isFolderDocument);
                onToggelFolderDocument(false);
              }}
            >
              <IconCollection name="editIcon" />
            </span>
          ) : null}
        </div>
        {fetchFolderDocumentRequest ? (
          <div className={css.spinner}>
            <IconSpinner />
          </div>
        ) : fetchFolderDocumentError ? (
          <div className={css.noDataText}>
            {intl.formatMessage({ id: 'FolderDocumentModal.fetchFolderDocumentError' })}
          </div>
        ) : (
          <>
            <ul className={css.documentList}>
              {userHaveDocumnetViewPermissions &&
              Array.isArray(allFolderDocumentData) &&
              allFolderDocumentData.length ? (
                allFolderDocumentData.map(item => (
                  <li key={item.id} className={css.documentItem}>
                    <div className={css.documentName}>
                      <div className={css.documentIcon}>
                        <iframe
                          src={`https://docs.google.com/gview?url=${item.documentURL}&embedded=true`}
                          width="46"
                          height="62"
                        />
                      </div>
                      <a
                        className={css.linkText}
                        target="_blank"
                        href={item.documentURL}
                        rel="noopener noreferrer"
                      >
                        {item.documentName}
                      </a>
                    </div>
                    {userHaveDocumnetUpadtePermissions ? (
                      <span
                        className={css.deleteIcon}
                        onClick={e => {
                          e.preventDefault();
                          if (!updateFolderDocumentRequest) {
                            onDeleteFolder(item);
                          }
                        }}
                      >
                        {updateFolderDocumentRequest == item._id ? (
                          <IconSpinner />
                        ) : (
                          <IconCollection name="deleteIcon" />
                        )}
                      </span>
                    ) : null}
                  </li>
                ))
              ) : (
                <li key={'No folder documents found'}>
                  <div className={css.noDataText}>
                    {intl.formatMessage({ id: 'FolderDocumentModal.noDocumentsFound' })}
                  </div>
                </li>
              )}
            </ul>
          </>
        )}
        {totalPages > 1 ? (
          <PaginationMyActivity
            currentPage={page}
            hasNextPage={page < totalPages}
            onPageChange={handlePageChange}
            posts_count={totalItems}
            per_page={perPage}
            isActiveTab={'documents'}
          />
        ) : null}
      </div>
    </Modal>
  );
};

export default FolderDocumentModal;
